export default class MatriculaService {
  constructor(resource) {
    this._resource = resource;
  }

  getInfoMatricula(ra, idHabilitacaoFilial, idPerletivo) {
    return this._resource
      .post("corpore/infoMatricula", { ra, idHabilitacaoFilial, idPerletivo })
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error("Não foi possível obter as informações da matrícula");
        }
      );
  }

  getAlteracoesDisponiveis(ra, idHabilitacaoFilial, idPerletivo, curso) {
    return this._resource
      .post("corpore/V2/disciplinasTurmasAluno", {
        ra,
        idHabilitacaoFilial,
        idPerletivo,
        curso
      })
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error("Não foi possível obter as alterações disponíveis");
        }
      );
  }

  getProcessoAlteracao(idPerletivo, codStatus, habilitacaoFilial = null) {
    return this._resource
      .post("matricula/processoAlteracao", {
        codStatus,
        idPerletivo,
        habilitacaoFilial
      })
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error(
            "Não foi possível obter o processo de alteração de matrícula"
          );
        }
      );
  }

  getMatriculasAlteracao(ra, codStatus) {
    return this._resource
      .get(`matricula/matriculasAlteracao/${ra}/${codStatus}`)
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error(
            "Não foi possível obter as matrículas disponíveis para alteração"
          );
        }
      );
  }

  getOcorrenciasAluno(ra, codPerlet, perletivo) {
    return this._resource
      .post("matricula/ocorrenciasAluno", { ra, codPerlet, perletivo })
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error("Não foi possível obter as ocorrências desse aluno");
        }
      );
  }

  getDisciplinasMatricula(ra) {
    return this._resource.get(`matricula/disciplina/${ra}`).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error("Não foi possível obter as disciplinas desse aluno");
      }
    );
  }

  getDisciplinasReprovadoMatricula(ra, curso) {
    return this._resource.get(`matricula/disciplina/reprovado/${ra}/${curso}`).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error("Não foi possível obter as disciplinas desse aluno");
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/domain/corpore/MatriculaService.js